import { createSlice } from '@reduxjs/toolkit';
import undoable from 'redux-undo';
import { LOCATE_TYPICAL_REDO, LOCATE_TYPICAL_UNDO, TYPICAL_FLOOR } from '../constants';
import { ITypicalFloorState, TSelectedFloorType } from '../types';
import { TBuildingLotType, TBuildingShapeLine } from '../../../share/types';
import { BUILDING } from '../../../share/constants';

const initialState: ITypicalFloorState = {
  selectedFloorType: TYPICAL_FLOOR as TSelectedFloorType,
  typicalFloorType: BUILDING.TYPES.RIGHT_CORNER_RECT as TBuildingLotType,
  typicalFloorWalls: [],
  groundFloorType: BUILDING.TYPES.RIGHT_CORNER_RECT as TBuildingLotType,
  groundFloorWalls: [],
  selectedTypeForCurrentFloor: BUILDING.TYPES.RIGHT_CORNER_RECT as TBuildingLotType,
};
const locateTypicalSlice = createSlice({
  name: 'locateTypical',
  initialState,
  reducers: {
    setTypicalFloorType(slice, { payload }: { payload: TBuildingLotType }) {
      return ({
        ...slice,
        typicalFloorType: payload,
      });
    },
    setTypicalFloorWalls(slice, { payload }: { payload: TBuildingShapeLine[] }) {
      return ({
        ...slice,
        typicalFloorWalls: payload,
      });
    },
    setSelectedFloorType(slice, { payload }: { payload: TSelectedFloorType }) {
      return ({
        ...slice,
        selectedFloorType: payload,
      });
    },
    setGroundFloorType(slice, { payload }: { payload: TBuildingLotType }) {
      return ({
        ...slice,
        groundFloorType: payload,
      });
    },
    setGroundFloorWalls(slice, { payload }: { payload: TBuildingShapeLine[] }) {
      return ({
        ...slice,
        groundFloorWalls: payload,
      });
    },
    setSelectedTypeForCurrentFloor(slice, { payload }: { payload: TBuildingLotType }) {
      return ({
        ...slice,
        selectedTypeForCurrentFloor: payload,
      });
    },
    resetLocateTypicalState(slice) {
      return ({
        ...slice,
        selectedFloorType: TYPICAL_FLOOR as TSelectedFloorType,
        typicalFloorType: BUILDING.TYPES.RIGHT_CORNER_RECT as TBuildingLotType,
        typicalFloorWalls: [],
        groundFloorType: BUILDING.TYPES.RIGHT_CORNER_RECT as TBuildingLotType,
        groundFloorWalls: [],
        selectedTypeForCurrentFloor: BUILDING.TYPES.RIGHT_CORNER_RECT as TBuildingLotType,
      });
    },
  },
});

export const undoLocateTypicalAction = () => ({ type: LOCATE_TYPICAL_UNDO });
export const redoLocateTypicalAction = () => ({ type: LOCATE_TYPICAL_REDO });

export const {
  setTypicalFloorType,
  setTypicalFloorWalls,
  setSelectedFloorType,
  setGroundFloorType,
  setGroundFloorWalls,
  setSelectedTypeForCurrentFloor,
  resetLocateTypicalState,
} = locateTypicalSlice.actions;

export const locateTypicalReducer = undoable(locateTypicalSlice.reducer, {
  limit: 10,
  undoType: LOCATE_TYPICAL_UNDO,
  redoType: LOCATE_TYPICAL_REDO,
});
